import type {Asset} from '@hconnect/common'
import {dataTestId} from '@hconnect/uikit'
import {Add} from '@mui/icons-material'
import {Button} from '@mui/material'
import {FC, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {useAddGrindingCircuit} from '../../hooks/grindingCircuits'
import {GrindingCircuitPayload} from '../../types'

import {GrindingCircuitsFormDialog} from './GrindingCircuitsFormDialog'

import {useUrlParam} from '@settings/modules/routing'

type GrindingCircuitsCreateProps = {
  assets?: Asset[]
}

export const GrindingCircuitsCreate: FC<GrindingCircuitsCreateProps> = ({assets}) => {
  const {t} = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

  const plantCode = useUrlParam('plantCode')
  const {mutate: createGrindingUnit, isPending} = useAddGrindingCircuit(() =>
    setIsDialogOpen(false)
  )

  const handleCreate = (data: GrindingCircuitPayload) =>
    createGrindingUnit({plantCode, grindingCircuitDto: data})

  return (
    <>
      <Button
        variant="text"
        startIcon={<Add />}
        sx={{ml: 2}}
        onClick={() => setIsDialogOpen(true)}
        {...dataTestId('add_grinding_circuit')}
      >
        {t('plantSetup.grindingCircuit.action.addNewCircuit')}
      </Button>

      {isDialogOpen && (
        <GrindingCircuitsFormDialog
          onSubmit={handleCreate}
          isLoading={isPending}
          assets={assets}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  )
}
